import React from 'react';
import { Inbox } from 'lucide-react';

export const EmptyState = ({ title = 'Belum ada data', description = '', action = null, icon: Icon = Inbox }) => (
  <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
    <div className="h-14 w-14 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center mb-3">
      <Icon className="h-6 w-6 text-muted-foreground" />
    </div>
    <div className="text-base font-semibold font-heading">{title}</div>
    {description ? <div className="text-sm text-muted-foreground mt-1 max-w-md">{description}</div> : null}
    {action ? <div className="mt-4">{action}</div> : null}
  </div>
);
